import { createTheme } from '@mui/material/styles';
import { scGray2, scGray5 } from 'constants/systemColors';
import { muiThemeLocales } from 'services/i18n/mui';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#691E44'
      },
      DataGrid: {
        bg: scGray2,
        headerBg: scGray2,
        pinnedBg: scGray2
      }
    },
    components: {
      MuiButtonBase: {
        styleOverrides: {
          root: {
            ':focus': {
              outline: 'none'
            }
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          sizeSmall: {
            fontSize: '12px',
            fontWeight: '400',
            lineHeight: '18px'
          }
        }
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            '& .MuiDataGrid-scrollbar::-webkit-scrollbar-track': {
              backgroundColor: scGray5
            }
          }
        }
      }
    }
  },
  ...muiThemeLocales
);

export default theme;
